module.exports = __webpack_public_path__ + "img/offer.6de67778.jpg";